<template>
  <modal
    content-class="domain-modal"
    :title="title"
    :back="!!selectedDomain"
    :max-width="maxWidth"
    :value="showing"
    @input="emitShowing"
    @back="clearSelectedDomain"
  >
    <loading v-if="loading" class="domain-modal-loading" />

    <template v-else>
      <domain-authenticate-modal
        :showing.sync="showingAuthenticateModal"
        @closed="show"
      />

      <domain-list
        v-if="showing && !selectedDomain"
        class="domain-modal-list"
        @selected="selectDomain"
      />

      <domain-authenticate-form-validate
        v-if="selectedDomain"
        :domain="selectedDomain"
      />

      <app-button
        v-if="!selectedDomain"
        class="domain-modal-action btn btn-primary btn-round"
        :label="$t('message.email.message.validateNewDomain')"
        primary
        @click="showAuthenticateModal"
      >
      </app-button>
    </template>
  </modal>
</template>

<script>
import AppButton from "@/components/generic/button/Button";
import Loading from "@/components/generic/Loading.vue";
import DomainAuthenticateFormValidate from "@components/modules/domain/authenticate/form/validate/DomainAuthenticateFormValidate";
import DomainList from "@components/modules/domain/list/DomainList";
import DomainAuthenticateModal from "@components/modules/domain/authenticate/modal/DomainAuthenticateModal";
import Modal from "@components/generic/Modal.vue";

export default {
  components: {
    Modal,
    DomainList,
    DomainAuthenticateModal,
    DomainAuthenticateFormValidate,
    Loading,
    AppButton,
  },
  data() {
    return {
      total: 0,
      loading: false,
      showingAuthenticateModal: false,
      selectedDomain: undefined,
    };
  },
  props: {
    showing: {
      type: Boolean,
      default: false,
    },
  },

  created() {},

  computed: {
    maxWidth() {
      return this.selectedDomain ? `80%` : 800;
    },
    title() {
      return this.selectedDomain
        ? this.selectedDomain.domain
        : this.$t("message.email.message.validatedDomains");
    },
  },

  watch: {},

  methods: {
    show() {
      this.emitShowing(true);
    },
    hide() {
      this.emitShowing(false);
    },
    showAuthenticateModal() {
      this.showingAuthenticateModal = true;
      this.hide();
    },
    onInput(value) {
      this.loading = false;
      this.clearSelectedDomain();
      this.emitShowing(value);
    },
    emitShowing(showing) {
      this.$emit("update:showing", showing);
    },
    async selectDomain(domain) {
      this.loading = true;

      const selectedDomain = await this.$api.marketing.email.dns.get({
        domainId: domain.senderDomainId,
      });

      this.selectedDomain = selectedDomain;

      this.loading = false;
    },
    clearSelectedDomain() {
      this.selectedDomain = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.domain-modal {
  display: flex;
  flex-direction: column;

  .domain-modal-loading {
    margin: 30px auto;
    width: 30px;
    height: 30px;
  }

  .domain-modal-list {
    max-height: 350px;
    overflow: scroll;
    margin-bottom: 15px;
  }

  .domain-modal-action {
    margin: 0 auto;
    border-radius: 20px !important;
  }
}
</style>
